<template>
  <div class="user-management">
    <div class="user-management-header" :style="exchangeHeader">
      <img src="~@/assets/img/usercenterHeader.png" class="user-management-header-img" />
      <div class="user-management-header-message white-cl">
        <p>
          <span class="nickname">{{ nickName }}</span>
          <svg-icon @click="modify(1)" icon-class="accountEditUserNameIcon"></svg-icon>
          <!-- <c-button @click="modify(1)" type="text">
            {{ this.$t("personal.tool.modify") }}
          </c-button> -->
        </p>
        <p class="username">{{ userName }}</p>
        <p class="userid">{{ this.$t("personal.userManagement.id") }}: {{ id }}</p>
      </div>
    </div>
    <div class="user-management-content a-7-bd main-second-bg">
      <p class="title medium b-1-cl a-3-bd">
        {{ this.$t("personal.userManagement.securityTitle") }}
      </p>
      <div class="user-management-main clearfix">
        <ul class="ul">
          <li class="li clearfix">
            <!--登录密码-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_login_password_icon"></svg-icon>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.password.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.password.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button
                  @click="changePassword"
                  className="li-fun"
                  type="solid"
                  paddingW="18px"
                  height="30px">
                  {{ this.$t("personal.tool.modify") }}
                </c-button>
                <!--
                <span class="li-fun b-4-cl clearfix" @click="changePassword">
                </span>
                -->
              </div>
            </div>
          </li>
          <li class="li clearfix">
            <!--实名认证-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_shieldtick"></svg-icon>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.idAuth.text") }}
              </p>
              <p class="b-2-cl" v-if="authLevel !== 1">
                {{ this.$t("personal.userManagement.securityList.idAuth.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button
                  v-if="authLevel === 0"
                  type="text"
                  className="li-fun"
                  @click="btnLink('goID')"
                >
                  {{ this.$t("personal.state.authentication") }}
                </c-button>
                <!--
                <span v-if="authLevel === 0" class="li-fun b-4-cl clearfix"
                      @click="btnLink('identity')">{{this.$t('personal').state.authentication}}
                </span>
                -->
                <span v-if="authLevel === 1" class="li-fun b-2-cl clearfix li-fun-no">
                  {{ this.$t("personal.state.certified") }}</span
                >
                <c-button
                  v-if="authLevel === 2 || authLevel === 3"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('identity')"
                >
                  {{ this.$t("personal.state.certification") }}</c-button
                >
              </div>
            </div>
          </li>
          <li class="li clearfix">
            <!--邮箱-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_email"></svg-icon>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.email.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.email.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button
                  v-if="email"
                  type="solid"
                  className="li-fun"
                  paddingW="18px"
                  height="30px"
                  @click="changeEmail">
                  {{ this.$t("personal.tool.modify") }}
                </c-button>
                <!--
                  <span v-if="email"
                  class="li-fun b-4-cl clearfix"
                  @click="changeEmail">{{this.$t('personal').tool.modify}}</span>
                -->
                <c-button
                v-else
                type="solid"
                :big="true"
                className="user-button"
                paddingW="18px"
                height="30px"
                @click="btnLink('email')"
                >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <p v-if="email" class="li-email b-2-cl clearfix">{{ email }}</p>
              </div>
            </div>
          </li>
          <li class="li clearfix">
            <!--手机号-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_phone"></svg-icon>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.phone.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.phone.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button v-if="smsCode && googleCode" type="text" className="li-fun li-fun1">
                  <router-link class="b-4-cl" to="/personal/closePhone">
                    {{ this.$t("personal.state.closeValidatio") }}</router-link
                  >
                </c-button>
                <c-button
                  v-if="!smsCode && mobileNumber"
                  className="li-fun"
                  type="text"
                  style="margin-left: 22px"
                  @click="openMobile"
                >
                  {{ this.$t("personal.state.openValidatio") }}
                </c-button>
                <c-button v-if="mobileNumber" type="text" className="li-fun">
                  <router-link class="b-4-cl" to="/personal/changePhone">
                    {{ this.$t("personal.tool.modify") }}</router-link
                  >
                </c-button>
                <c-button
                  v-if="!mobileNumber"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('phone')"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <p class="li-email b-2-cl clearfix" v-if="mobileNumber">{{ mobileNumber }}</p>
              </div>
            </div>
          </li>
          <li class="li clearfix" style="border-bottom-width: inherit">
            <!--谷歌验证码-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_google_verify"></svg-icon>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.google.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.phone.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button v-if="smsCode && googleCode" type="text" className="li-fun">
                  <router-link class="b-4-cl" to="/personal/closeGoogle">
                    {{ this.$t("personal.state.closeValidatio") }}</router-link
                  >
                </c-button>
                <!--
                <span v-if="smsCode&&googleCode" class="li-fun b-4-cl clearfix">
                  <router-link class="b-4-cl" to="/personal/closeGoogle">
                    {{this.$t('personal').state.closeValidatio}}</router-link></span>
                    -->
                <c-button
                  v-if="!googleCode"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('google')"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <span v-if="googleCode && !smsCode" class="li-fun clearfix">
                  {{ this.$t("personal.state.open") }}</span
                >
              </div>
            </div>
          </li>
        </ul>
        <p class="title medium b-1-cl a-3-bd clearfix title2" v-show="feeCoinOpen === '1'">
          {{ this.$t("personal.userManagement.otherTitle") }}
        </p>
        <ul class="ul">
          <!-- 1.0版本隐藏平台币作为手续费功能 -->
          <!--平台币作为手续费-->
          <!-- <li class="li">
            <svg-icon class="li-icon icon icon-16" icon-class="personal_fee"></svg-icon>
            <div class="li-div a-3-bd b-1-cl">
              <p class="li-title">
                {{ this.$t("personal.userManagement.otherList.poundage.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.otherList.poundage.label") }}
              </p>
              <div class="li-right">
                <c-switch-big :circleWidth="20" :circleHeight="20" :width="48" :height="28" :value="switchValue" @click="switchChange" />
              </div>
            </div>
          </li> -->
          <li class="li" v-if="userInfo && userInfo.inviteUrl">
            <!--我的邀请码-->
            <svg-icon class="li-icon icon icon-16" icon-class="personal_invite"></svg-icon>
            <div class="li-div a-3-bd b-1-cl">
              <p class="li-title">
                {{ this.$t("personal.userManagement.otherList.myInviteCod.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.otherList.myInviteCod.label") }}
              </p>
              <div class="li-right">
                <c-button @click="modify(2)" type="text">
                  {{ this.$t("personal.tool.view") }}
                </c-button>
              </div>
            </div>
          </li>
          <li class="li" v-if="superPeerShow">
            <img
              style="width: 24px"
              class="li-icon"
              src="../../assets/images/1/super_peer.png"
              alt=""
            />
            <div class="li-div a-3-bd b-1-cl">
              <p class="li-title">
                {{ this.$t("personal.userManagement.otherList.superPeerCod.text") }}
              </p>
              <div class="li-right">
                <c-button @click="goSuper" type="text">
                  {{ this.$t("personal.tool.view") }}
                </c-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="0px"
      paddingTop="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="checkErrorFlag"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="titleText"
    >
      <!-- 验证框 -->
      <c-inputLine
        v-if="dialogType === 1"
        name="checkValue"
        maxLength="10"
        :promptText="promptText"
        :errorHave="true"
        :errorText="errorText"
        :errorFlag="checkErrorFlag"
        marginTop="26px"
        :value="checkValue"
        errorTigger="change"
        @onchanges="inputChanges"
      >
      </c-inputLine>
      <div
        class="clearfix invite-link-box"
        v-if="userInfo && userInfo.agentStatus === 1 && dialogType === 2">
        <c-button
          @click="goAgent"
          className="invite-link"
          type="text"
        >
          {{ this.$t("personal.userManagement.inviteLink") }}
        </c-button>
      </div>
      <div class="dialog-div" v-if="dialogType === 2">
        <div class="dialog-div-module">
          <p class="gray-cl">{{ $t("personal.label.inviteCode") }}</p>
          <p class="copyArea gray-30-bg gray-cl">
            <span>{{ inviteCode }}</span>
            <span
              @click="copyClick('inviteCode')"
              @mouseenter="handMouseenter('inviteCode')"
              @mouseleave="handMouseleave('inviteCode')"
            >
            <svg-icon v-if="inviteCode" class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
            </span>
          </p>
        </div>
        <div class="dialog-div-module">
          <p class="gray-cl">{{ $t("personal.label.inviteUrl") }}</p>
          <p class="copyArea gray-30-bg gray-cl">
            <span>{{ inviteUrl }}</span>
            <span
              @click="copyClick('inviteUrlShow')"
              @mouseenter="handMouseenter('inviteUrlShow')"
              @mouseleave="handMouseleave('inviteUrlShow')"
            >
            <svg-icon v-if="inviteUrl" class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
            </span>
          </p>
        </div>
        <div class="dialog-div-module">
          <p class="gray-cl">{{ $t("personal.label.inviteQECode") }}</p>
          <div class="img-div main-second-bg">
            <img :src="inviteQECode" />
          </div>
        </div>
      </div>
    </c-dialog>
    <!-- 实名认证 -->
    <c-dialog
      :showFlag="kycPhoneFlag"
      paddingBottom="14px"
      :titleText="$t('personal.idAuth.title')"
      @close="kycPhoneClose"
      @confirm="kycPhoneConfirm"
      :confirmLoading="kycLoading"
    >
      <!-- 请选择您的国家或地区 -->
      <c-select
        :value="country"
        :promptText="$t('personal.kyc.area')"
        @onChanges="countryChange"
        name="certificateType"
        :imgMap="imgMap"
        :errorHave="true"
        :options="countryListMoy"
        :filterable="true"
        newStyleFormat
      />
    </c-dialog>
    <!-- 提示框 -->
    <c-alert
      :showFlag="alertFlag"
      :buttonText="this.$t('personal').alert.button"
      imageType="1"
      :imgMap="imgMap"
      :title="$t('personal.alert.title')"
      @close="alertClose"
      @confirm="alertGo"
    >
      <div class="alertText">{{ this.$t("personal.alert.text") }}</div>
      <div class="alertError gray-10-bd">
        <svg-icon :iconClass="googleCode ? 'icon-right-answer' : 'icon-wrong-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text mian-cl"> {{ $t("personal.alert.alertErrorTextGoogle") }}</span>
      </div>
      <div class="alertError alertBot gray-10-bd">
        <svg-icon :iconClass="smsCode ? 'icon-right-answer' : 'icon-wrong-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text mian-cl"> {{ $t("personal.alert.alertErrorTextPhone") }}</span>
      </div>
    </c-alert>
    <kycAuthselect
      :countryVal="country.split('+')[1]"
      :countryKeyCodeVal="countryKeyCode.split('+')[1]"
    />
  </div>
</template>

<script>
import { imgMap, colorMap } from '@/utils';
import countryMinix from 'BlockChain-ui-privatization/PC/common-mixin/countryList/countryList';
import zcLogoBg from '@/assets/img/zc-logo-bg.png';
import kycAuthselect from './kycAuthselect.vue';

export default {
  name: 'userManagement',
  components: { kycAuthselect },
  mixins: [countryMinix],
  data() {
    return {
      exchangeHeader: `background: url(${zcLogoBg});background-size: cover;`,
      id: '', // uid
      mobileNumber: '', // 手机号或者邮箱显示
      authLevel: '', // 身份/实名认证状态，0、未审核，1、通过，2、未通过  3未认证
      nickName: '', // 昵称
      userName: '',
      email: '', // 邮箱
      dialogFlag: false,
      dialogConfirmLoading: false,
      checkErrorFlag: false,
      checkValue: '',
      promptText: this.$t('personal.dialog.name'),
      errorText: this.$t('personal.dialog.text'),
      oldName: '', // 用户最初昵称
      smsCode: false, // false对应0 关闭 true对应1 开启(手机短信认证)
      googleCode: false, // false对应0 关闭 true对应1 开启(google认证)
      switchValue: false, // 手续费设置
      clickType: true, // 可点击状态
      alertFlag: false,
      imgMap,
      colorMap,
      feeCoinOpen: '0',
      dialogType: 1,
      inviteCodeShow: true,
      inviteUrlShow: true,
      superPeerShow: false,
      // 邀请码信息
      inviteCode: '',
      inviteQECode: '',
      inviteUrl: '',
      titleText: this.$t('personal.dialog.title'),
      kycPhoneFlag: false, // kyc选择国家弹窗
      country: '', // kyc用户选择的国家
      kycLoading: false,
      state: 'KYC_AUTH',
    };
  },
  watch: {
    // 默认区号
    defaultCountryCode(v) {
      if (v && this.country === '') {
        this.country = v;
      }
    },
    userInfo(userinfo) {
      // 监听userinfo接口
      if (userinfo) {
        this.getUserInfo(); // 获取用户信息
      }
      this.googleCode = !!Number(userinfo.googleStatus);
      this.smsCode = !!Number(userinfo.isOpenMobileCheck);
      this.id = userinfo.id;
    },
    modifyNickName(modifyNickName) {
      // 修改昵称逻辑操作
      if (modifyNickName !== null) {
        if (modifyNickName.text === 'success') {
          // tip框提示
          this.$bus.$emit('tip', { text: modifyNickName.msg, type: 'success' });
          // 重新获取 userinfo
          this.$store.dispatch('getUserInfo');
          this.dialogConfirmFlag = false;
          this.dialogFlag = false;
          this.checkValue = this.oldName;
          this.checkErrorFlag = false;
          this.dialogConfirmLoading = false;
          this.$store.dispatch('resetType');
        } else {
          // tip框提示错误
          this.$bus.$emit('tip', { text: modifyNickName.msg, type: 'error' });
          this.$store.dispatch('resetType');
          this.dialogConfirmLoading = false;
        }
      }
    },
    openMobileVerify(openMobileVerify) {
      if (openMobileVerify !== null) {
        if (openMobileVerify.text === 'success') {
          this.$bus.$emit('tip', { text: openMobileVerify.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$store.dispatch('getUserInfo');
        } else {
          this.$bus.$emit('tip', { text: openMobileVerify.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    updateFeeCoinOpen(updateFeeCoinOpen) {
      if (updateFeeCoinOpen !== null) {
        const type = this.switchValue;
        if (updateFeeCoinOpen.text === 'success') {
          if (type) {
            this.$bus.$emit('tip', {
              text: this.$t('personal.state.closeSuccess'),
              type: 'success',
            });
            this.switchValue = !type;
            this.$store.dispatch('resetType');
          } else {
            this.$bus.$emit('tip', {
              text: this.$t('personal.state.openSuccess'),
              type: 'success',
            });
            this.switchValue = !type;
            this.$store.dispatch('resetType');
          }
        } else {
          this.$bus.$emit('tip', { text: updateFeeCoinOpen.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
  },
  computed: {
    interfaceSwitch() {
      return this.$store.state.baseData.interfaceSwitch;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    modifyNickName() {
      return this.$store.state.personal.modifyNickName;
    },
    openMobileVerify() {
      return this.$store.state.personal.openMobileVerify;
    },
    updateFeeCoinOpen() {
      return this.$store.state.personal.updateFeeCoinOpen;
    },
    headImg() {
      return imgMap.head;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    // ”00“ face++
    // ”01“羽山kyc
    // “02”简版自动
    // ”10“ 人工
    nameVerifiedType() {
      return this.$store.state.baseData.nameVerifiedType;
    },
  },
  mounted() {
    // this.judgeIsMmSuperUser();
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('getUserInfo');
      // if (window.location.href.includes('zh_CN')) {
      //   this.country = '+156';
      // } else {
      //   this.country = '+840';
      // }
    },
    goAgent() {
      this.$router.push('/agent');
    },
    // kyc 弹窗关闭
    kycPhoneClose() {
      // 关闭弹窗
      this.kycPhoneFlag = false;
      // 初始化select内容
      // this.country = this.defaultCountryCodeReal
      //   ? this.defaultCountryCodeReal
      //   : this.countryMap[this.defaultCountryCode].code; // 所在地
      this.country = '';
      this.countryKeyCode = this.defaultCountryCode ? this.defaultCountryCode : ''; // 所在地
    },
    // kyc 弹窗确认
    kycPhoneConfirm() {
      // 中国人 - 认证face++
      if (this.nameVerifiedType === '00' && this.country === '+156') {
        this.axios({
          url: '/kyc/Api/get_Valid_QRcode',
        }).then((data) => {
          this.kycLoading = false;
          if (data.code.toString() === '0') {
            const { openAuto, limitFlag } = data.data;
            if (
              (openAuto && openAuto.toString() === '0')
              || (limitFlag && limitFlag.toString() === '1')
            ) {
              // if (kycSingaporeOpen && kycSingaporeOpen !== '0') {
              //   this.$store.dispatch('exccKycConfig', {});
              // } else {
              this.$router.push('/personal/idAuth?country=156&countryKeyCode=86');
              // }
            } else {
              this.$router.push('/personal/faceAuth?country=156&countryKeyCode=86');
            }
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        });
        // 外国人 - 认证
      } else {
        // if (kycSingaporeOpen && kycSingaporeOpen !== '0') {
        //   this.$store.dispatch('exccKycConfig', {});
        // } else {
        const countryNum = this.country.split('+')[1];
        const countryKeyCodeNum = this.countryKeyCode.split('+')[1];
        this.$router.push(
          `/personal/idAuth?country=${countryNum}&countryKeyCode=${countryKeyCodeNum}`,
        );
        // }
        this.kycLoading = false;
      }
    },
    copyClick(name) {
      if (name === 'inviteCode') {
        this.copy(this.inviteCode);
      } else {
        this.copy(this.inviteUrl);
      }
    },
    copy(str) {
      this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    handMouseenter(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = false;
      } else {
        this.inviteUrlShow = false;
      }
    },
    handMouseleave(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = true;
      } else {
        this.inviteUrlShow = true;
      }
    },
    btnLink(link) {
      if (link === 'google') {
        this.$router.push('/personal/bindGoogle');
      } else if (link === 'phone') {
        this.$router.push('/personal/bindPhone');
      } else if (link === 'email') {
        this.$router.push('/personal/bindEmail');
      } else if (link === 'identity') {
        this.kycPhoneFlag = true;
      } else if (link === 'goID') {
        this.$router.push('/personal/idAuth');
      }
    },

    dialogClose() {
      // 关闭或取消时
      this.dialogConfirmFlag = false;
      this.dialogFlag = false;
      this.checkValue = this.oldName;
      this.checkErrorFlag = false;
    },

    dialogConfirm() {
      // 点击确认时
      if (this.dialogType === 2) {
        this.dialogConfirmFlag = false;
        this.dialogFlag = false;
      } else if (this.checkNickName()) {
        // 非空提交
        this.dialogConfirmLoading = true;
        const val = this.checkValue;
        this.$store.dispatch('modifyNickName', { nickname: val });
      }
    },

    /**
     * 检查昵称是否合法
     */
    checkNickName() {
      let checkValidate = false;
      const val = this.checkValue;
      if (val.length === 0) {
        // 为空提示
        this.checkErrorFlag = true;
        this.errorText = this.$t('personal.userManagement.nameError1');
      } else if (val.length > 10) {
        this.checkErrorFlag = true;
        this.errorText = this.$t('personal.userManagement.nameError2');
      } else if (!this.validateInput(val)) {
        this.checkErrorFlag = true;
        this.errorText = this.$t('personal.userManagement.nameError3');
      } else {
        checkValidate = true;
        this.checkErrorFlag = false;
      }
      return checkValidate;
    },

    /**
     * 校验仅允许使用英文字母、数字、中文和特殊字符
     */
    validateInput(input) {
      const pattern = /^[a-zA-Z0-9\u4e00-\u9fa5_-]*$/;
      return pattern.test(input);
    },

    /**
     * 输入框发生变化时同时触发校验
     */
    inputChanges(val) {
      // 获取输入框内容
      this.checkValue = val;
      this.checkNickName();
    },

    modify(num) {
      if (num === 1) {
        this.dialogType = 1;
        this.titleText = this.$t('personal.dialog.title');
      } else {
        this.dialogType = 2;
        this.titleText = this.$t('personal.userManagement.otherList.myInviteCod.text');
      }
      this.dialogConfirmFlag = true;
      this.dialogFlag = true;
    },

    goSuper() {
      this.$router.push('/mmf/mmfSuperPeer');
    },

    judgeIsMmSuperUser() {
      // 判断是否为超级节点
      this.axios({
        url: 'mm/agent/judgeIsMmSuperUser',
        headers: {},
        params: {},
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          if (data.data) {
            this.superPeerShow = true;
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },

    getUserInfo() {
      if (this.userInfo !== null) {
        // 邀请码信息
        this.inviteCode = this.userInfo.inviteCode;
        this.inviteQECode = this.userInfo.inviteQECode;
        this.inviteUrl = this.userInfo.inviteUrl;
        // 邀请码信息
        this.userName = this.userInfo.mobileNumber !== '' ? this.userInfo.mobileNumber : this.userInfo.email; // 有电话号码显示电话号码,无则显示邮箱
        this.mobileNumber = this.userInfo.mobileNumber; // 电话号码
        this.nickName = this.userInfo.nickName !== ''
          ? this.userInfo.nickName
          : this.$t('personal.userManagement.userName');
        this.email = this.userInfo.email; // 邮箱
        this.checkValue = this.userInfo.nickName;
        this.oldName = this.userInfo.nickName;
        this.authLevel = this.userInfo.authLevel; // 身份认证状态
        if (Number(this.userInfo.useFeeCoinOpen) === 1) {
          // 是否开启手续费设置 1 开启 0 关闭
          this.switchValue = true;
        } else {
          this.switchValue = false;
        }
        this.feeCoinOpen = this.userInfo.fee_coin_open;
      }
    },
    openMobile() {
      this.$store.dispatch('openMobileVerify');
    },
    switchChange() {
      if (this.clickType) {
        this.clickType = false;
        setTimeout(() => {
          this.clickType = true;
        }, 1000);
        if (this.switchValue) {
          const info = { useFeeCoinOpen: '0' };
          this.$store.dispatch('updateFeeCoinOpen', info);
        } else {
          const info = { useFeeCoinOpen: '1' };
          this.$store.dispatch('updateFeeCoinOpen', info);
        }
      }
    },
    changePassword() {
      if (this.smsCode === true || this.googleCode === true) {
        this.$router.push('/personal/changePassword');
      } else {
        this.alertFlag = true;
      }
    },
    changeEmail() {
      if (this.smsCode === true || this.googleCode === true) {
        this.$router.push('/personal/changeEmail');
      } else {
        this.alertFlag = true;
      }
    },
    alertClose() {
      this.alertFlag = false;
    },
    alertGo() {
      this.alertFlag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-management {
  width: 100%;
  .user-management-header {
    width: 100%;
    float: left;
    position: relative;
    margin-bottom: 24px;
    border-radius: 6px;
  }
  .invite-link-box {
    padding-bottom: 15px;
  }
  .invite-link {
    float: right;
  }
  .user-management-header-img {
    float: left;
    width: 75px;
    height: 75px;
    margin: 38px 0 37px 20px;
  }
  .user-management-header-img2 {
    float: right;
    height: 122px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .user-management-header-message {
    float: left;
    margin: 30px 0 0 30px;
    font-size: 12px;
    .nickname {
      font-size: 14px;
    }
    .username {
      font-size: 18px;
    }
    .userid {
      font-size: 16px;
    }
    p {
      svg {
        font-size: 14px;
        margin-left: 10px;
        cursor: pointer;
        color: white;
      }
    }
  }
  .user-management-header-message p:nth-of-type(1) span {
    line-height: 24px;
  }
  .user-management-header-message span:nth-of-type(2) {
    margin-left: 10px;
    cursor: pointer;
  }
  .user-management-header-message p:nth-of-type(2) {
    margin: 10px 0 15px 0;
    font-size: 22px;
    font-weight: normal;
  }
  .user-management-content {
    float: left;
    width: 100%;
    min-height: 594px;
    overflow: hidden;
    border-top-style: solid;
    padding-bottom: 30px;
    border-radius: 6px;
    .title {
      padding: 20px;
      font-size: 14px;
      letter-spacing: 0;
      text-align: left;
      line-height: 16px;
      border-bottom-style: solid;
      border-bottom-width: 1px;
    }
    .title2 {
      width: 940px;
      border-top-style: solid;
      /* border-top-width: 1px; */
    }
    ul {
      overflow: hidden;
    }
  }
  .user-management-main {
    width: 100%;
    float: left;
  }
  .user-management-main ul:last-of-type li:first-of-type {
    display: block !important;
  }
  .user-management-main ul li {
    width: 100%;
    float: left;
  }
  .li-icon {
    float: left;
    font-size: 14px;
    margin: 25px 20px;
  }

  .li-div {
    float: left;
    width: 910px;
    height: 64px;
    box-sizing: border-box;
    font-size: 14px;
    position: relative;
  }
  .li-div:last-of-type(1) {
    border-bottom-style: none;
    border-bottom-width: 0px;
  }
  .li-div p:nth-of-type(1) {
    margin-top: 10px;
    line-height: 24px;
  }
  .li-div p:nth-of-type(1).switchBottom,
  .li-div p:nth-of-type(1).switchBottomChecked {
    margin-top: 0;
  }
  .li-div p:nth-of-type(1).none {
    margin-top: 32px;
  }
  .li-div p:nth-of-type(2) {
    margin-top: 5px;
    font-size: 12px;
  }
  .li-right {
    position: absolute;
    top: 22px;
    right: 21px;
    float: right;
    .common-button {
      top: -5px;
    }
  }
  .li-fun {
    float: right;
    font-size: 12px;
    cursor: pointer;
  }
  .li-fun-no {
    cursor: default;
  }
  .li-fun1 {
    margin-left: 20px;
  }
  .li-div p:nth-of-type(1).li-email {
    font-family: Medium;
    margin-top: 0;
    font-size: 12px;
    float: right;
    margin-right: 22px;
    line-height: 18px;
  }
  .user-button {
    font-size: 12px;
    margin-top: -10px;
    .switchWrap {
      top: -15px;
    }
  }
  .alertTitle {
    margin-bottom: 15px;
  }
  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }
  .alertError {
    height: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding: 10px 24px;
    box-sizing: border-box;
    .alertError-text {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  .alertBot {
    margin-bottom: 16px;
  }
  .dialog-div {
    .dialog-div-module {
      padding: 18px 0 15px 0;
      .copyArea {
        border-radius: 4px;
        padding: 14px 16px;
        font-size: 14px;
        font-family: 'Regular';
      }

      p:nth-of-type(1) {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        span:nth-of-type(2) {
          float: right;
        }
      }
      .img-div {
        width: 180px;
        height: 180px;
        margin: 0 auto;
        border-radius: 6px;
        overflow: hidden;
        img {
          width: 180px;
          height: 180px;
        }
      }
    }
  }
}
</style>
